import React from 'react';
import { Select } from 'antd';
import SegmentsTable from './SegmentsTable';
import SegmentsRingChart from './SegmentsRingChart';
import EntityBreakdownCard from '../../../../../shared/designSystem/components/EntityBreakdownCard';
import { MenuItemText } from '../../../../../shared/globalStyling/styledText';
import { getRingColor } from '../../../../../shared/designSystem/components/BreakdownRingChart';

const { Option } = Select;

const KEY_COLORS = {
  spent: '#1665d8',
  remaining: '#34aa44',
  budget: '#030303',
  total: '#bec0c3',
  value: '#99999',
};

// Dimension choice terms are segment-specific:
//   ais = ad impressions (served)
//   ctr = click-through rate (already in 0–100 form)
//   clicks = clicks
const SHOW_BY_OPTIONS = [
  { value: 'ais', text: 'Ad Impressions' },
  { value: 'ctr', text: 'CTR Percentage' },
  { value: 'clicks', text: 'Clicks' },
];

// =============================================================================
// SegmentsDetails — unified Segments + Breakdown card. Mirrors Creatives /
// Publishers layout without a search input (v1 didn't ship one for segments).
// =============================================================================

const SegmentsDetails = (props) => {
  const { selectedSegmentsDimension, setSegmentsDimension, segmentsData } = props;

  const colorValuePairs = segmentsData.map((el, index) => {
    if (el.retargeting_name) {
      return { ...el, value: el.retargeting_name, color: getRingColor(index) };
    } else if (el.value) {
      return { ...el, color: getRingColor(index) };
    }
    return { ...el, value: `Segments ${index}`, color: getRingColor(index) };
  });

  return (
    <EntityBreakdownCard
      title="Segments"
      table={<SegmentsTable segmentsData={colorValuePairs} />}
      breakdownControl={
        <Select
          defaultValue={SHOW_BY_OPTIONS[0].value}
          onChange={(value) => setSegmentsDimension(value)}
          getPopupContainer={(trigger) => trigger.parentNode}
          popupClassName="mjl-ds"
          className="campaign-overview__creatives-showby"
          size="small"
        >
          {SHOW_BY_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          ))}
        </Select>
      }
      breakdownChart={
        <SegmentsRingChart
          data={colorValuePairs}
          keyColors={KEY_COLORS}
          height={480}
          selectedSegmentsDimension={selectedSegmentsDimension}
        />
      }
    />
  );
};

export default SegmentsDetails;
